module.exports = __webpack_public_path__ + "img/logo button.d093274b.png";